module.exports = __webpack_public_path__ + "static/img/device_limit.cf8af677.png";